import { SVG, SVGProps } from './svg'

export function IconToolRect(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M24.5 21.06V10.94a2 2 0 10-2.44-2.44H9.94a2 2 0 10-2.44 2.44v10.12a2 2 0 102.44 2.44h12.12a2 2 0 102.44-2.44zM9.94 9.5a2 2 0 01-1.44 1.44v10.12a2 2 0 011.44 1.44h12.12a2 2 0 011.44-1.44V10.94a2 2 0 01-1.44-1.44H9.94zM9 9a1 1 0 11-2 0 1 1 0 012 0zm15 1a1 1 0 100-2 1 1 0 000 2zM8 24a1 1 0 100-2 1 1 0 000 2zm17-1a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </SVG>
  )
}
